module.exports = __webpack_public_path__ + "img/Geländestapler.d9a7a4bd.svg";